import React, { PureComponent, PropTypes } from 'react';
import PassengerSeat from 'components/AirlineSeatSelection/PassengerSeat';
import LinkButton from 'components/LinkButton/LinkButton';

import './SeatListNavigationHeader.scss';

export default class SeatListNavigationHeader extends PureComponent {
  static propTypes = {
    counter: PropTypes.number.isRequired,
    paxType: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    direction: PropTypes.string.isRequired,
    showDoneButton: PropTypes.bool.isRequired,
    selectNext: PropTypes.func,
    selectPrevious: PropTypes.func,
  };

  static defaultProps = {
    selectNext: undefined,
    selectPrevious: undefined,
  };

  handlePreviousClick = (event) => {
    const { selectPrevious } = this.props;

    event.preventDefault();
    if (selectPrevious) {
      selectPrevious();
    }
  };

  handleNextClick = (event) => {
    const { selectNext } = this.props;

    event.preventDefault();
    if (selectNext) {
      selectNext();
    }
  };

  render() {
    const { counter, paxType, label, direction, selectPrevious, selectNext, showDoneButton } = this.props;

    return (
      <div className="seat-list-navigation-header">
        <div onClick={this.handlePreviousClick} className={`seat-list-navigation-header__button seat-list-navigation-header__button--${selectPrevious ? 'enabled' : 'disabled'} seat-list-navigation-header__button--previous`} />
        <div className="seat-list-navigation-header__icon">
          <PassengerSeat counter={counter} paxType={paxType} />
        </div>
        <p className="seat-list-navigation-header__text">
          Select <span className="seat-list-navigation-header__text--shout">{direction}</span> seat for <span className="seat-list-navigation-header__text--shout">{label}</span>:
        </p>
        {
          showDoneButton ? (
            <div className="seat-list-navigation-header__button seat-list-navigation-header__button--done">
              <LinkButton onClick={this.handleNextClick}>Done</LinkButton>
            </div>
          ) : (
            <div onClick={this.handleNextClick} className={`seat-list-navigation-header__button seat-list-navigation-header__button--${selectNext ? 'enabled' : 'disabled'} seat-list-navigation-header__button--next`} />
          )
        }
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/AirlineSeatSelection/SeatListNavigationHeader.jsx
 **/